import { CardAdvancement, CardElement, CardFaction, CardGrade, CardRarity, CardType, } from '@cta-portal/webapp-common/lib/api/schema';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { MarketSection, MarketTab, MyAssetsTab } from '../../app/router/config';
import { SettingsContext } from '../../context/settings';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { SortDirection, TokenType } from '../../types/common';
import { MAX_POWER_VALUE, MIN_POWER_VALUE } from '../../utils/card-powers';
import { compareArrays } from '../../utils/common';
import { ItemsOrderBy } from '../market/use-items';
import { AssetsOrderBy } from '../market/use-my-assets';
import { ProductsOrderBy } from '../market/use-products';
import { useInput } from './use-input';
export function useFilters(options) {
    var location = useLocation();
    var searchParams = useSearchParams()[0];
    var navigate = useNavigate();
    var setShowFilters = useContext(SettingsContext).setShowFilters;
    var searchQuery = useInput(getDefaultSearchQuery());
    var _a = useState(getDefaultTokenType()), tokenTypes = _a[0], setTokenTypes = _a[1];
    var _b = useState(getDefaultCollections()), collections = _b[0], setCollections = _b[1];
    var _c = useState(getDefaultCollections()), collectionsTmp = _c[0], setCollectionsTmp = _c[1];
    var _d = useState(getDefaultSets()), sets = _d[0], setSets = _d[1];
    var _e = useState(getDefaultSets()), setsTmp = _e[0], setSetsTmp = _e[1];
    var _f = useState(getDefaultAdvancements()), advancements = _f[0], setAdvancements = _f[1];
    var _g = useState(getDefaultAdvancements()), advancementsTmp = _g[0], setAdvancementsTmp = _g[1];
    var _h = useState(getDefaultElements()), elements = _h[0], setElements = _h[1];
    var _j = useState(getDefaultElements()), elementsTmp = _j[0], setElementsTmp = _j[1];
    var _k = useState(getDefaultRarities()), rarities = _k[0], setRarities = _k[1];
    var _l = useState(getDefaultRarities()), raritiesTmp = _l[0], setRaritiesTmp = _l[1];
    var _m = useState(getDefaultMinPower()), minPower = _m[0], setMinPower = _m[1];
    var _o = useState(getDefaultMinPower()), minPowerTmp = _o[0], setMinPowerTmp = _o[1];
    var _p = useState(getDefaultMaxPower()), maxPower = _p[0], setMaxPower = _p[1];
    var _q = useState(getDefaultMaxPower()), maxPowerTmp = _q[0], setMaxPowerTmp = _q[1];
    var _r = useState(getDefaultFactions()), factions = _r[0], setFactions = _r[1];
    var _s = useState(getDefaultFactions()), factionsTmp = _s[0], setFactionsTmp = _s[1];
    var _t = useState(getDefaultGrades()), grades = _t[0], setGrades = _t[1];
    var _u = useState(getDefaultGrades()), gradesTmp = _u[0], setGradesTmp = _u[1];
    var _v = useState(getDefaultRanks()), ranks = _v[0], setRanks = _v[1];
    var _w = useState(getDefaultRanks()), ranksTmp = _w[0], setRanksTmp = _w[1];
    var _x = useState(getDefaultFoil()), foils = _x[0], setFoils = _x[1];
    var _y = useState(getDefaultFoil()), foilsTmp = _y[0], setFoilsTmp = _y[1];
    var _z = useState(getDefaultAnimationLevels()), animationLevels = _z[0], setAnimationLevels = _z[1];
    var _0 = useState(getDefaultAnimationLevels()), animationLevelsTmp = _0[0], setAnimationLevelsTmp = _0[1];
    var _1 = useState(getDefaultCardTypes()), cardTypes = _1[0], setCardTypes = _1[1];
    var _2 = useState(getDefaultCardTypes()), cardTypesTmp = _2[0], setCardTypesTmp = _2[1];
    var _3 = useState(getDefaultMintPassTypes()), mintPassTypes = _3[0], setMintPassTypes = _3[1];
    var _4 = useState(getDefaultMintPassTypes()), mintPassTypesTmp = _4[0], setMintPassTypesTmp = _4[1];
    var _5 = useState(getDefaultNumbering()), numberings = _5[0], setNumberings = _5[1];
    var _6 = useState(getDefaultNumbering()), numberingsTmp = _6[0], setNumberingsTmp = _6[1];
    var _7 = useState(false), numberingsCustom = _7[0], setNumberingsCustom = _7[1];
    var _8 = useState(false), numberingsCustomTmp = _8[0], setNumberingsCustomTmp = _8[1];
    var _9 = useState(getDefaultCurrencyTokens()), currencyTokens = _9[0], setCurrencyTokens = _9[1];
    var _10 = useState(getDefaultCurrencyTokens()), currencyTokensTmp = _10[0], setCurrencyTokensTmp = _10[1];
    var _11 = useState(false), showApplyFilters = _11[0], setShowApplyFilters = _11[1];
    var _12 = useState(getDefaultOrderBy()), orderBy = _12[0], setOrderBy = _12[1];
    var _13 = useState(getDefaultDirection()), direction = _13[0], setDirection = _13[1];
    var _14 = useState(options === null || options === void 0 ? void 0 : options.tab), tab = _14[0], setTab = _14[1];
    var _15 = useState(false), initialized = _15[0], setInitialized = _15[1];
    useEffect(function () {
        var sortOptions = getSortOptionsFromTab();
        setOrderBy(function (value) { return (initialized ? sortOptions.orderBy : value); });
        setDirection(function (value) { return (initialized ? sortOptions.direction : value); });
        setTab(options === null || options === void 0 ? void 0 : options.tab);
        setTimeout(function () { return setInitialized(true); }, 200);
    }, [options === null || options === void 0 ? void 0 : options.tab]);
    useEffect(function () {
        var tokenType;
        if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.MINT_PASSES) {
            tokenType = TokenType.MINT_PASS;
        }
        else if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.ARISE) {
            tokenType = TokenType.ARISE_COIN;
        }
        else if (tokenTypes[0] === TokenType.MINT_PASS || tokenTypes[0] === TokenType.ARISE_COIN) {
            tokenType = TokenType.CARD;
        }
        setTokenTypes(function (value) { return (tokenType ? [tokenType] : value); });
    }, [options === null || options === void 0 ? void 0 : options.section]);
    useEffect(function () {
        if (initialized) {
            clearAll();
        }
    }, [tokenTypes]);
    useEffect(function () {
        var newMaxPowder = maxPower < minPower ? MAX_POWER_VALUE : maxPower;
        setMaxPower(newMaxPowder);
        setMaxPowerTmp(newMaxPowder);
    }, [minPower, maxPower]);
    useEffect(function () {
        if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.MINT_PASSES) {
            var urlParam_1 = "?tokenType=".concat(TokenType.MINT_PASS);
            if (mintPassTypes.length > 0 && tokenTypes[0] === TokenType.MINT_PASS) {
                urlParam_1 += "&mintPassTypes=".concat(mintPassTypes.join(','));
            }
            if (searchQuery.value.length > 0 && !(options === null || options === void 0 ? void 0 : options.fromProduct)) {
                urlParam_1 += "&search=".concat(encodeURI(searchQuery.value));
            }
            if (numberings.length > 0 && !numberingsCustom) {
                urlParam_1 += "&numberings=".concat(numberings[numberings.length - 1] + 1);
            }
            navigate("".concat(location.pathname).concat(urlParam_1), { replace: true });
            return;
        }
        if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.ARISE) {
            var urlParam_2 = "?tokenType=".concat(TokenType.ARISE_COIN);
            if (rarities.length > 0 && tokenTypes[0] === TokenType.ARISE_COIN) {
                urlParam_2 += "&rarities=".concat(rarities.join(','));
            }
            if (searchQuery.value.length > 0 && !(options === null || options === void 0 ? void 0 : options.fromProduct)) {
                urlParam_2 += "&search=".concat(encodeURI(searchQuery.value));
            }
            navigate("".concat(location.pathname).concat(urlParam_2), { replace: true });
            return;
        }
        var urlParam = tokenTypes.length > 0 ? "?tokenType=".concat(tokenTypes[0]) : '';
        if (collections.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&collections=".concat(collections.join(','));
        }
        if (sets.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&sets=".concat(sets.join(','));
        }
        if (advancements.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&advancements=".concat(advancements.join(','));
        }
        if (elements.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&elements=".concat(elements.join(','));
        }
        if (rarities.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&rarities=".concat(rarities.join(','));
        }
        if (minPower !== MIN_POWER_VALUE && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&minPower=".concat(minPower);
        }
        if (maxPower !== MAX_POWER_VALUE && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&maxPower=".concat(maxPower);
        }
        if (factions.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&factions=".concat(factions.join(','));
        }
        if (grades.length > 0 && (tokenTypes[0] === TokenType.CARD || tokenTypes[0] === TokenType.SOUVENIR_CARD)) {
            urlParam += "&grades=".concat(grades.join(','));
        }
        if (ranks.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&ranks=".concat(ranks.join(','));
        }
        if (foils.length > 0 && (tokenTypes[0] === TokenType.CARD || tokenTypes[0] === TokenType.SOUVENIR_CARD)) {
            urlParam += "&foils=".concat(foils.join(','));
        }
        if (animationLevels.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&animationLevels=".concat(animationLevels.join(','));
        }
        if (cardTypes.length > 0 && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&types=".concat(cardTypes.join(','));
        }
        if (numberings.length > 0 && !numberingsCustom && tokenTypes[0] === TokenType.CARD) {
            urlParam += "&numberings=".concat(numberings[numberings.length - 1] + 1);
        }
        if (currencyTokens.length > 0) {
            urlParam += "&currencyTokens=".concat(currencyTokens.join(','));
        }
        if (searchQuery.value.length > 0 && !(options === null || options === void 0 ? void 0 : options.fromProduct)) {
            urlParam += "&search=".concat(encodeURI(searchQuery.value));
        }
        if (!(options === null || options === void 0 ? void 0 : options.fromProduct)) {
            urlParam += "&orderBy=".concat(orderBy);
            urlParam += "&direction=".concat(direction);
        }
        navigate("".concat(location.pathname).concat(urlParam), { replace: true });
    }, [
        tokenTypes,
        collections,
        sets,
        advancements,
        elements,
        rarities,
        minPower,
        maxPower,
        factions,
        grades,
        ranks,
        foils,
        animationLevels,
        cardTypes,
        mintPassTypes,
        numberings,
        currencyTokens,
        orderBy,
        direction,
        searchQuery.value,
        options === null || options === void 0 ? void 0 : options.section,
        options === null || options === void 0 ? void 0 : options.tab,
    ]);
    useEffect(function () {
        setShowApplyFilters(!compareArrays(collections, collectionsTmp) ||
            !compareArrays(sets, setsTmp) ||
            !compareArrays(advancements, advancementsTmp) ||
            !compareArrays(elements, elementsTmp) ||
            !compareArrays(rarities, raritiesTmp) ||
            minPower !== minPowerTmp ||
            maxPower !== maxPowerTmp ||
            !compareArrays(factions, factionsTmp) ||
            !compareArrays(grades, gradesTmp) ||
            !compareArrays(ranks, ranksTmp) ||
            !compareArrays(foils, foilsTmp) ||
            !compareArrays(animationLevels, animationLevelsTmp) ||
            !compareArrays(cardTypes, cardTypesTmp) ||
            !compareArrays(mintPassTypes, mintPassTypesTmp) ||
            !compareArrays(numberings, numberingsTmp) ||
            numberingsCustom !== numberingsCustomTmp ||
            !compareArrays(currencyTokens, currencyTokensTmp));
    }, [
        collections,
        collectionsTmp,
        sets,
        setsTmp,
        advancements,
        advancementsTmp,
        elements,
        elementsTmp,
        rarities,
        raritiesTmp,
        minPower,
        minPowerTmp,
        maxPower,
        maxPowerTmp,
        factions,
        factionsTmp,
        grades,
        gradesTmp,
        ranks,
        ranksTmp,
        foils,
        foilsTmp,
        animationLevels,
        animationLevelsTmp,
        cardTypes,
        cardTypesTmp,
        mintPassTypes,
        mintPassTypesTmp,
        numberings,
        numberingsTmp,
        numberingsCustom,
        numberingsCustomTmp,
        currencyTokens,
        currencyTokensTmp,
    ]);
    function applyFilters() {
        setCollections(collectionsTmp);
        setSets(setsTmp);
        setAdvancements(advancementsTmp);
        setElements(elementsTmp);
        setRarities(raritiesTmp);
        setMinPower(minPowerTmp);
        setMaxPower(maxPowerTmp);
        setFactions(factionsTmp);
        setGrades(gradesTmp);
        setRanks(ranksTmp);
        setFoils(foilsTmp);
        setAnimationLevels(animationLevelsTmp);
        setCardTypes(cardTypesTmp);
        setMintPassTypes(mintPassTypesTmp);
        setNumberings(numberingsTmp);
        setNumberingsCustom(numberingsCustomTmp);
        setCurrencyTokens(currencyTokensTmp);
        setShowFilters(window.innerWidth > 640);
    }
    function getDefaultTokenType() {
        if (options === null || options === void 0 ? void 0 : options.tokenType)
            return [options.tokenType];
        if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.MINT_PASSES)
            return [TokenType.MINT_PASS];
        if ((options === null || options === void 0 ? void 0 : options.section) === MarketSection.ARISE)
            return [TokenType.ARISE_COIN];
        var defaultTokenTypes = (options === null || options === void 0 ? void 0 : options.fromAssets) ? [] : [TokenType.CARD];
        var tokenTypeParam = searchParams.get('tokenType');
        return tokenTypeParam && tokenTypeParam !== 'all' && Object.values(TokenType).includes(tokenTypeParam)
            ? [tokenTypeParam]
            : defaultTokenTypes;
    }
    function getDefaultCollections() {
        var _a;
        var result = [];
        var collectionsParam = (_a = searchParams.get('collections')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (collectionsParam) {
            for (var _i = 0, collectionsParam_1 = collectionsParam; _i < collectionsParam_1.length; _i++) {
                var param = collectionsParam_1[_i];
                var paramNumber = Number.parseInt(param);
                if (!Number.isNaN(paramNumber) && paramNumber > 0 && paramNumber <= 3) {
                    result.push(paramNumber);
                }
            }
        }
        return result;
    }
    function getDefaultSets() {
        var _a;
        var result = [];
        var setsParam = (_a = searchParams.get('sets')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (setsParam) {
            for (var _i = 0, setsParam_1 = setsParam; _i < setsParam_1.length; _i++) {
                var param = setsParam_1[_i];
                var paramNumber = Number.parseInt(param);
                if (!Number.isNaN(paramNumber) && paramNumber > 0 && paramNumber <= 2) {
                    result.push(paramNumber);
                }
            }
        }
        return result;
    }
    function getDefaultAdvancements() {
        var _a;
        var result = [];
        var advancementParams = (_a = searchParams.get('advancements')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (advancementParams) {
            for (var _i = 0, advancementParams_1 = advancementParams; _i < advancementParams_1.length; _i++) {
                var param = advancementParams_1[_i];
                if (Object.values(CardAdvancement).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultElements() {
        var _a;
        var result = [];
        var elementsParams = (_a = searchParams.get('elements')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (elementsParams) {
            for (var _i = 0, elementsParams_1 = elementsParams; _i < elementsParams_1.length; _i++) {
                var param = elementsParams_1[_i];
                if (Object.values(CardElement).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultRarities() {
        var _a;
        var result = [];
        var raritiesParams = (_a = searchParams.get('rarities')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (raritiesParams) {
            for (var _i = 0, raritiesParams_1 = raritiesParams; _i < raritiesParams_1.length; _i++) {
                var param = raritiesParams_1[_i];
                if (Object.values(CardRarity).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultMinPower() {
        var minPowerParamStr = searchParams.get('minPower');
        var minPowerParam = minPowerParamStr ? Number.parseInt(minPowerParamStr) : undefined;
        return minPowerParam && !Number.isNaN(minPowerParam) ? minPowerParam : MIN_POWER_VALUE;
    }
    function getDefaultMaxPower() {
        var maxPowerParamStr = searchParams.get('maxPower');
        var maxPowerParam = maxPowerParamStr ? Number.parseInt(maxPowerParamStr) : undefined;
        return maxPowerParam && !Number.isNaN(maxPowerParam) ? maxPowerParam : MAX_POWER_VALUE;
    }
    function getDefaultFactions() {
        var _a;
        var result = [];
        var raritiesParams = (_a = searchParams.get('factions')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (raritiesParams) {
            for (var _i = 0, raritiesParams_2 = raritiesParams; _i < raritiesParams_2.length; _i++) {
                var param = raritiesParams_2[_i];
                if (Object.values(CardFaction).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultGrades() {
        var _a;
        var result = [];
        var gradesParams = (_a = searchParams.get('grades')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (gradesParams) {
            for (var _i = 0, gradesParams_1 = gradesParams; _i < gradesParams_1.length; _i++) {
                var param = gradesParams_1[_i];
                if (Object.values(CardGrade).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultRanks() {
        var _a;
        var result = [];
        var ranksParam = (_a = searchParams.get('ranks')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (ranksParam) {
            for (var _i = 0, ranksParam_1 = ranksParam; _i < ranksParam_1.length; _i++) {
                var param = ranksParam_1[_i];
                var paramNumber = Number.parseInt(param);
                if (!Number.isNaN(paramNumber) && paramNumber > 0 && paramNumber <= 5) {
                    result.push(paramNumber);
                }
            }
        }
        return result;
    }
    function getDefaultFoil() {
        var _a;
        var result = [];
        var ranksParam = (_a = searchParams.get('foils')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (ranksParam) {
            for (var _i = 0, ranksParam_2 = ranksParam; _i < ranksParam_2.length; _i++) {
                var param = ranksParam_2[_i];
                if (param === 'true')
                    result.push(true);
                if (param === 'false')
                    result.push(false);
            }
        }
        return result;
    }
    function getDefaultAnimationLevels() {
        var _a;
        var result = [];
        var animationLevelsParam = (_a = searchParams.get('animationLevels')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (animationLevelsParam) {
            for (var _i = 0, animationLevelsParam_1 = animationLevelsParam; _i < animationLevelsParam_1.length; _i++) {
                var param = animationLevelsParam_1[_i];
                var paramNumber = Number.parseInt(param);
                if (!Number.isNaN(paramNumber) && paramNumber > 0 && paramNumber <= 2) {
                    result.push(paramNumber);
                }
            }
        }
        return result;
    }
    function getDefaultCardTypes() {
        var _a;
        var result = [];
        var cardTypesParams = (_a = searchParams.get('types')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (cardTypesParams) {
            for (var _i = 0, cardTypesParams_1 = cardTypesParams; _i < cardTypesParams_1.length; _i++) {
                var param = cardTypesParams_1[_i];
                if (Object.values(CardType).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultMintPassTypes() {
        var _a;
        var result = [];
        var mintPassTypesParams = (_a = searchParams.get('mintPassTypes')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (mintPassTypesParams) {
            for (var _i = 0, mintPassTypesParams_1 = mintPassTypesParams; _i < mintPassTypesParams_1.length; _i++) {
                var param = mintPassTypesParams_1[_i];
                result.push(param);
            }
        }
        return result;
    }
    function getDefaultNumbering() {
        var numberingParams = searchParams.get('numberings');
        var parsedNumbering = numberingParams ? Number.parseInt(numberingParams) : undefined;
        var result = [];
        if (parsedNumbering &&
            !isNaN(parsedNumbering) &&
            (parsedNumbering === 10 || parsedNumbering === 50 || parsedNumbering === 100)) {
            for (var i = 1; i < parsedNumbering; i++) {
                result.push(i);
            }
            return result;
        }
        return [];
    }
    function getDefaultCurrencyTokens() {
        var _a;
        var result = [];
        var currencyTokensParams = (_a = searchParams.get('currencyTokens')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (currencyTokensParams) {
            for (var _i = 0, currencyTokensParams_1 = currencyTokensParams; _i < currencyTokensParams_1.length; _i++) {
                var param = currencyTokensParams_1[_i];
                if (Object.values(CurrencyTokenSymbol).includes(param)) {
                    result.push(param);
                }
            }
        }
        return result;
    }
    function getDefaultSearchQuery() {
        var searchParam = searchParams.get('search');
        return searchParam ? decodeURI(searchParam) : '';
    }
    function getSortOptionsFromTab() {
        if ((options === null || options === void 0 ? void 0 : options.tab) === MarketTab.PRODUCTS) {
            return tokenTypes[0] === TokenType.CARD
                ? { orderBy: ProductsOrderBy.POWER, direction: SortDirection.DESC }
                : { orderBy: ProductsOrderBy.NAME, direction: SortDirection.ASC };
        }
        if ((options === null || options === void 0 ? void 0 : options.tab) === MarketTab.ITEMS) {
            return { orderBy: ItemsOrderBy.PRICE, direction: SortDirection.ASC };
        }
        if ((options === null || options === void 0 ? void 0 : options.tab) === MarketTab.ACTIVITIES) {
            return { orderBy: ItemsOrderBy.DATE, direction: SortDirection.DESC };
        }
        if ((options === null || options === void 0 ? void 0 : options.tab) === MyAssetsTab.ON_SALE) {
            return { orderBy: ItemsOrderBy.PRICE, direction: SortDirection.ASC };
        }
        return { orderBy: AssetsOrderBy.NAME, direction: SortDirection.ASC };
    }
    function getDefaultOrderBy() {
        var sortOptions = getSortOptionsFromTab();
        var orderByParam = searchParams.get('orderBy');
        return orderByParam ? orderByParam : sortOptions.orderBy;
    }
    function getDefaultDirection() {
        var sortOptions = getSortOptionsFromTab();
        var directionParam = searchParams.get('direction');
        return directionParam ? directionParam : sortOptions.direction;
    }
    function clearAll() {
        searchQuery.setValue('');
        setCollections([]);
        setCollectionsTmp([]);
        setSets([]);
        setSetsTmp([]);
        setAdvancements([]);
        setAdvancementsTmp([]);
        setElements([]);
        setElementsTmp([]);
        setRarities([]);
        setRaritiesTmp([]);
        setMinPowerTmp(MIN_POWER_VALUE);
        setMaxPowerTmp(MAX_POWER_VALUE);
        setGrades([]);
        setGradesTmp([]);
        setFactions([]);
        setFactionsTmp([]);
        setFoils([]);
        setFoilsTmp([]);
        setRanks([]);
        setRanksTmp([]);
        setAnimationLevels([]);
        setAnimationLevelsTmp([]);
        setCardTypes([]);
        setCardTypesTmp([]);
        setMintPassTypes([]);
        setMintPassTypesTmp([]);
        setNumberings([]);
        setNumberingsTmp([]);
        setNumberingsCustom(false);
        setNumberingsCustomTmp(false);
        setCurrencyTokens([]);
        setCurrencyTokensTmp([]);
    }
    return {
        state: {
            searchQuery: searchQuery,
            tokenTypes: tokenTypes,
            collections: collections,
            collectionsTmp: collectionsTmp,
            sets: sets,
            setsTmp: setsTmp,
            advancements: advancements,
            advancementsTmp: advancementsTmp,
            elements: elements,
            elementsTmp: elementsTmp,
            rarities: rarities,
            raritiesTmp: raritiesTmp,
            minPower: minPower,
            minPowerTmp: minPowerTmp,
            maxPower: maxPower,
            maxPowerTmp: maxPowerTmp,
            factions: factions,
            factionsTmp: factionsTmp,
            gradesTmp: gradesTmp,
            grades: grades,
            ranks: ranks,
            ranksTmp: ranksTmp,
            foils: foils,
            foilsTmp: foilsTmp,
            animationLevels: animationLevels,
            animationLevelsTmp: animationLevelsTmp,
            cardTypes: cardTypes,
            cardTypesTmp: cardTypesTmp,
            mintPassTypes: mintPassTypes,
            mintPassTypesTmp: mintPassTypesTmp,
            numberings: numberings,
            numberingsTmp: numberingsTmp,
            numberingsCustom: numberingsCustom,
            numberingsCustomTmp: numberingsCustomTmp,
            currencyTokens: currencyTokens,
            currencyTokensTmp: currencyTokensTmp,
            showApplyFilters: showApplyFilters,
            orderBy: orderBy,
            direction: direction,
            tab: tab,
        },
        actions: {
            clearAll: clearAll,
            applyFilters: applyFilters,
            setTokenTypes: setTokenTypes,
            setCollections: setCollectionsTmp,
            setSets: setSetsTmp,
            setAdvancements: setAdvancementsTmp,
            setElements: setElementsTmp,
            setRarities: setRaritiesTmp,
            setMinPower: setMinPowerTmp,
            setMaxPower: setMaxPowerTmp,
            setFactions: setFactionsTmp,
            setGrades: setGradesTmp,
            setRanks: setRanksTmp,
            setFoils: setFoilsTmp,
            setAnimationLevels: setAnimationLevelsTmp,
            setCardTypes: setCardTypesTmp,
            setMintPassTypes: setMintPassTypesTmp,
            setNumberings: setNumberingsTmp,
            setNumberingsCustom: setNumberingsCustomTmp,
            setCurrencyTokens: setCurrencyTokensTmp,
            setOrderBy: setOrderBy,
            setDirection: setDirection,
        },
    };
}
